import {http} from "@/assets/utils/api";

/**
 * 获取回复&获赞数
 */
export const getReplyCount = () => http.get('/user/courseCount');

/**
 * 我发布的（主题列表）
 */
export const getMyDiscussList = (params) => http.get('/yymCourseDiscuss/myList',{params});

/**
 * 我的点赞（主题列表）
 */
export const getMyLikedList = (params) => http.get('/yymCourseDiscuss/myLikeList',{params});

/**
 * 我发布的（回复列表）
 */
export const getMyReplyList = (params) => http.get('/yymCourseCommentReply/myList',{params});

/**
 * 我发布的（评价列表）
 */
export const getEvaluationList = (params) => http.get('/yymCourseAppraise/myList',{params});

/**
 * 我的点赞（回复列表）
 */
export const getMyLikedReply = (params) => http.get('/yymCourseCommentReply/myLikeList',{params});

/**
 * 我的点赞（评价列表）
 */
export const getMyLiedEvaluateList = (params) => http.get('/yymCourseAppraise/myLikeList',{params});

/**
 * 验证手机号
 */
export const checkPhone = (params) => http.get('/user/checkUser',{params});

/**
 * 更换手机号
 */
export const changePhone = (data) => http.post('/user/updatePhone',data);

/**
 * 修改密码
 */
export const passwordUpdate = (data) => http.post('/user/updatePassword',data);

/**
 * 忘记密码
 * @param {*} data 
 * @returns 
 */
export const forgotPassword = (data) => http.post('/user/forgetPassword',data,{custom:{isAuth:false}});

/**
 * 实名认证
 */
export const realNameVerify = (data) => http.post('/user/idCardVerification',data);

/**
 * 修改个人信息
 */
export const updatePersonalInfo = (data) => http.post('/user/update',data);

/**
 * 申请成为讲师
 */
export const teacherApply = (data) => http.post('/yymCourseLecturerApply/add',data);

/**
 * 删除我发布的主题
 */
export const deleteMyTheme = (id) => http.post('/yymCourseDiscuss/delete/'+id);

/**
 * 删除我发布的回复
 */
export const deleteMyReply = (id) => http.post('/yymCourseCommentReply/delete/'+id);

/**
 * 删除我发布的评价
 */
export const deleteMyAppraise = (id) => http.post('/yymCourseAppraise/delete/'+id);

/**
 * 积分签到列表
 */
export const getSignInList = (params) => http.get('/yymSigninReward/getMemberReward',{params});

/**
 * 签到
 */
export const signIn = (params) => http.get('/yymUserSigninRecord/userSignin',{params});

/**
 * 查询家庭关系列表
 */
export const getFamilyList = (params) => http.get('/yymFamilyMembers/getAll',{params});

/**
 * 添加家庭成员
 */
export const addFamily = (data) => http.post('/yymFamilyMembers/add',data);

/**
 * 查询家庭关系列表
 */
export const getFamilyTree = (params) => http.get('/yymFamilyTree/getAll',{params});

/**
 * 根据手机号查询（防止手机号是未注册的）
 */
export const searchFamilyByPhone = (params) => http.get('/yymFamilyMembers/getUser',{params});

/**
 * 解绑家庭关系
 */
export const delFamilyRelationship = (params) => http.delete('/yymFamilyMembers/delete',{params});

/**
 * 新手积分任务列表
 */
export const getBignnerTask = (params) => http.get('/yymWxytaskBase/getWxytaskNovice',{params});

/**
 * 日常积分任务列表
 */
export const getDailyTask = (params) => http.get('/yymWxytaskBase/getWxytaskDaily',{params});

/**
 * 我的提问
 */
export const getMyQuestion = (params) => http.get('/yymAccompanyingQnaManagement/qna/list',{params});

/**
 * 我的伴学师
 */
export const getMyTeacherList = () => http.get('/yymAccompanyingQnaManagement/tutors');